module.exports = __webpack_public_path__ + "static/media/Series6.f82bd448.pdf";